module.exports = __webpack_public_path__ + "img/icons B_9.4500843f.svg";